class Difference {
    output = {
        first: {
            $absolute: null,
            $percentage: null,
        },
        last: {
            $absolute: null,
            $percentage: null,
        }
    };

    value = 0;

    difference = {
        first: 0,
        last: 0,
    };

    percentage = {
        first: 0,
        last: 0,
    };

    constructor($el) {
        this.$el = $el;

        this.first = this.$el.data('first') ? parseFloat(this.$el.data('first')) : 0;
        this.last = this.$el.data('last') ? parseFloat(this.$el.data('last')) : 0;

        this.$input = this.$el.find('input');

        this.output.first.$absolute = this.$el.find('[data-difference="absolute-first"]');
        this.output.first.$percentage = this.$el.find('[data-difference="percentage-first"]');

        this.output.last.$absolute = this.$el.find('[data-difference="absolute-last"]');
        this.output.last.$percentage = this.$el.find('[data-difference="percentage-last"]');

        this.unit = this.$el.data('unit') ? this.$el.data('unit') : 'kg'

        if (this.first != 0 || this.last != 0) {
            this.init();
        }

    }

    init = () => {
        this.$input.on('change', this.changeHandler);

        this.changeHandler();
    }

    changeHandler = () => {
        this.value = this.$input.val() != "" ? parseFloat(this.$input.val()) : 0;

        // calculate differences
        this.difference.first = this.value - this.first;
        this.difference.last = this.value - this.last;

        this.percentage.first = this.first != 0 ? Number.parseFloat((this.value / this.first) * 100).toFixed(0) - 100 : '—';
        this.percentage.last = this.last != 0 ? Number.parseFloat((this.value / this.last) * 100).toFixed(0) - 100 : '—';

        this.output.first.$absolute.text(`${this.difference.first > 0 ? '+' : ''}${this.difference.first != 0 ? this.difference.first : '—'} ${this.unit}`);
        this.output.last.$absolute.text(`${this.difference.last > 0 ? '+' : ''}${this.difference.last != 0 ? this.difference.last : '—'} ${this.unit}`);

        this.output.first.$percentage.text(this.percentage.first >= 0 ? `+${this.percentage.first}%` : `${this.percentage.first}%`);
        this.output.last.$percentage.text(this.percentage.last >= 0 ? `+${this.percentage.last}%` : `${this.percentage.last}%`);
    }
}

export default Difference;
